// AuthHelper.js
export const isAuthenticated = () => {
  return !!localStorage.getItem("token");
};
export const getSessionCount = () => {
  return localStorage.getItem("sessionCount");
};
export const checkIsTempPwd = () => {
  return localStorage.getItem("isTempPwd");
};
